import { gql } from "@apollo/client";

export const HOLD_SEATS_FOR_SALE = gql`
  mutation HoldSeatsForSale($input: HoldChartEventSeatsForSaleInput!) {
    holdSeatsForSale(input: $input) {
      holdToken
      holdExpiresAt
      seats {
        seatId
        holdToken
        status
      }
    }
  }
`;
 
export const RELEASE_SEATS_FOR_SALE = gql`
  mutation ReleaseSeatsForSale($input: ReleaseChartEventSeatsForSaleInput!) {
    releaseSeatsForSale(input: $input)
  }
`;